import { render } from "./ThankYouComponent.vue?vue&type=template&id=0d632582&scoped=true"
import script from "./ThankYouComponent.vue?vue&type=script&lang=js"
export * from "./ThankYouComponent.vue?vue&type=script&lang=js"

import "./ThankYouComponent.vue?vue&type=style&index=0&id=0d632582&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d632582"]])

export default __exports__